import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Department } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class DepartmentModule extends VuexModule {
    @Action
    [Department.findPageDepartment](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/department/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Department.listDepartment](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/department/list`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Department.saveDepartment](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/department/save`, values,{ onUploadProgress: onUploadProgress })
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Department.deleteDepartment](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.delete(`/department/delete/${values}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}